module.exports = __webpack_public_path__ + "static/media/finestlink-v3.e839c482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/finestlink-v3.png
// module id = 318
// module chunks = 0